module.exports = __webpack_public_path__ + "static/media/bean.c3780c28.jpg";